export default __webpack_public_path__ + "static/media/gallery-wip-pommel-cap_01.eba7db28.jpg";